import React, {useState} from 'react'
import Update from '@page-components/Checkout/Checkout/Delivery/Address/Update'

import Time from '../Time'

import styles from './styles.module.css'

export default function DeliveryOptions({preferences, isFromHeader, layout}) {
  const {address, store, placeId} = preferences
  const [loading, setLoading] = useState(false)
  const time =
    store && address && !loading ? (
      <div className={styles.selectTime}>
        <Time
          preferences={preferences}
          // @ts-expect-error ts-migrate(2769) FIXME: No overload matches this call.
          showDirections={!!placeId && placeId !== 'no-deliver'}
        />
      </div>
    ) : null

  return (
    <Update
      preferences={preferences}
      autoSave
      showOutOfBoundsMsg={true}
      showMapRight={layout === 'v1' ? false : true}
      isFromHeader={isFromHeader}
      time={time}
      loading={loading}
      setLoading={setLoading}
    />
  )
}
